import {ApartmentOutlined, BusinessCenterOutlined, HomeOutlined, HotelOutlined, LocationCityOutlined} from '@material-ui/icons';
export const parseAddressTypeToIcons = (addressType) => {
  switch (addressType) {
    case 'home':
      return <HomeOutlined />;
    case 'condo':
      return <ApartmentOutlined />
    case 'hotel':
      return <HotelOutlined />
    case 'office':
      return <BusinessCenterOutlined />
    default:
      return <LocationCityOutlined />
  }
}